import Devider from './Devider';
import AboutPage from './AboutPage';
import OurServices from './OurServices';

export { Devider, AboutPage, OurServices };
